export default __webpack_public_path__ + "static/media/img-v3-footer-mobile.cc18b9e3.png";